var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape9 = function SvgShape9(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 68,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M151.79 79.7c0 8.653-7.015 15.668-15.669 15.668H15.881C7.225 95.368.21 88.353.21 79.7v-3.278C.21 34.564 34.143.631 76 .631c41.857 0 75.789 33.933 75.789 75.79z",
    opacity: 0.1
  })));
};
export default SvgShape9;